import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const FAQS = [{
  q: '1 — ¿Cómo recibo el pack después de comprar?',
  a: 'Al completar el pago recibís un email con el link de descarga inmediata. Acceso en menos de 5 minutos. Compatible con cualquier dispositivo.'
}, {
  q: '2 — ¿Sirve para cualquier provincia de Argentina?',
  a: 'Sí. El contenido está alineado al diseño curricular nacional. Lo usamos docentes de Buenos Aires, Córdoba, Rosario, Tucumán, Neuquén y todo el país.'
}, {
  q: '3 — ¿Los 6 bonus están en las dos ofertas?',
  a: 'Sí. Los 6 bonus estratégicos están incluidos tanto en el Pack Completo ($18.990) como en el Pack Elite ($27.990). Sin costo extra.'
}, {
  q: '4 — ¿Sirve si soy docente nuevo o con poca experiencia?',
  a: 'Especialmente para vos. El pack incluye secuencias didácticas con objetivo, desarrollo y evaluación. No necesitás experiencia previa para usarlo.'
}, {
  q: '5 — ¿Qué diferencia tiene con otros materiales que vi en internet?',
  a: 'El Portugués 360 está 100% adaptado al alumno argentino, con referencias al español rioplatense, falsos amigos y contraste lingüístico. No es material de Portugal ni de España.'
}, {
  q: '6 — ¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% sin preguntas. Más de 500 docentes lo usan con menos del 1% de devoluciones.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-white py-20 px-4" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-bold text-center text-deep-green mb-12" data-id="element-100">
          ❓ Preguntas frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-101">
          {FAQS.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-102">
              <button onClick={() => toggleFAQ(i)} className="w-full flex items-center justify-between p-5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" aria-expanded={openIndex === i} data-id="element-103">
                <span className="font-bold text-deep-green pr-4" data-id="element-104">{faq.q}</span>
                <span className="text-deep-green flex-shrink-0" data-id="element-105">
                  {openIndex === i ? <Minus size={20} data-id="element-106" /> : <Plus size={20} data-id="element-107" />}
                </span>
              </button>

              <AnimatePresence data-id="element-108">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-109">
                    <div className="p-5 bg-white text-gray-600 text-sm leading-relaxed border-t border-gray-100" data-id="element-110">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}